var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","fillRule":"evenodd","stroke":"#2F2E2E","strokeWidth":"1.5","d":"M1.071 1l7.071 7.071-7.07 7.071"}));
}

Arrow.displayName = "Arrow";

Arrow.defaultProps = {"width":"10","height":"16","viewBox":"0 0 10 16"};

module.exports = Arrow;

Arrow.default = Arrow;



//////////////////
// WEBPACK FOOTER
// ../node_modules/svg-react-loader/lib/loader.js!./components/fullscreen/storeMobileComponents/arrow.svg
// module id = 235
// module chunks = 1 2 3 4